import { popperProps as i } from "./index665.js";
import { defineComponent as l, ref as e, computed as d, provide as _, renderSlot as u } from "vue";
import { POPPER_INJECTION_KEY as P } from "./index558.js";
var g = /* @__PURE__ */ l({
  name: "ElPopper",
  inheritAttrs: !1,
  __name: "popper",
  props: i,
  setup(r, { expose: p }) {
    const t = r, n = e(), s = e(), c = e(), f = e(), m = d(() => t.role), o = {
      /**
       * @description trigger element
       */
      triggerRef: n,
      /**
       * @description popperjs instance
       */
      popperInstanceRef: s,
      /**
       * @description popper content element
       */
      contentRef: c,
      /**
       * @description popper reference element
       */
      referenceRef: f,
      /**
       * @description role determines how aria attributes are distributed
       */
      role: m
    };
    return p(o), _(P, o), (a, R) => u(a.$slots, "default");
  }
});
export {
  g as default
};
